import { Dayjs } from 'dayjs';

export function getDayIdByDate(date: Dayjs) {
  switch (date.day()) {
    case 1:
      return 'Lu';
    case 2:
      return 'Ma';
    case 3:
      return 'Mi';
    case 4:
      return 'Ju';
    case 5:
      return 'Vi';
    case 6:
      return 'Sa';
    case 0:
      return 'Do';
    default:
      return 'Lu';
  }
}
